import React from "react";
import { BottomNavigation, BottomNavigationAction, Paper, useMediaQuery, useTheme } from "@mui/material";
import { HomeOutlined, Person2Outlined, ChatOutlined, CachedOutlined, KeyOutlined } from "@mui/icons-material";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

interface ButtomMenuBarProps {
    onHomeRequest?: () => void;
    onMeRequest?: () => void;
    onRequirementClick?: () => void;
    onChatClick?: () => void;
}

export const ButtomMenuBar = ({ onMeRequest, onRequirementClick, onChatClick }: ButtomMenuBarProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { t, i18n } = useTranslation('common');
    const router = useRouter();

    const onLinkMenuClicked = (type: string) => {
        if (type === 'default') {
            router.push('/');
            return;
        }

        const url = i18n.language === 'th' ? `/${t(type)}/${t('estate')}` : `/${i18n.language}/${t(type)}/${t('estate')}`;
        router.push(url);
        // window.location.href = url;
    }
    return isMobile ? (<>
    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1001 }} elevation={6}>
        <BottomNavigation showLabels>
            <BottomNavigationAction label={t('bottomMenu.home')} icon={<HomeOutlined />}  sx={{ pl: 1.5, pr: 0.5 }} onClick={() => { onLinkMenuClicked('default'); }} />
            <BottomNavigationAction label={t('bottomMenu.require')} icon={<ChatOutlined />} sx={{ pl: 0.5, pr: 0.5 }} onClick={() => { onRequirementClick?.() }} />
            <BottomNavigationAction label={t('bottomMenu.sell')} icon={<CachedOutlined />} sx={{ pl: 0.5, pr: 0.5 }} onClick={() => { onLinkMenuClicked('link.sell'); }} />
            <BottomNavigationAction label={t('bottomMenu.rent')} icon={<KeyOutlined />}  sx={{ pl: 0.5, pr: 0.5 }} onClick={() => { onLinkMenuClicked('link.rent'); }}/>
            {/* <BottomNavigationAction label="Chat" icon={<FontAwesomeIcon icon={faComment} size="lg" />} onClick={() => { onChatClick?.(); }} /> */}
            <BottomNavigationAction label={t('bottomMenu.me')} icon={<Person2Outlined />} sx={{ pl: 0.5, pr: 1.5 }} onClick={() => { onMeRequest?.(); }} />
        </BottomNavigation>
    </Paper>
    </>) : <></>;
}